<template>
  <div>
    <!-- <p class="c-inner-title">模板消息群发管理</p> -->
    <div class="auto">
      <page-title title="模板消息群发管理" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="addHandle" class="el-icon-plus" size="small"> 添加任务</el-button>
              <el-button type="primary" @click="syncTemplateList" class="el-icon-refresh" size="small"> 同步消息</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-select v-model="filter.template_id" placeholder="请选择模板" size="small" class="m-lr-5">
                <el-option
                  key=""
                  label="请选择模板"
                  value="">
                </el-option>
                <el-option
                  v-for="item in temList"
                  :key="item.template_id"
                  :label="item.title"
                  :value="String(item.template_id)">
                </el-option>
              </el-select>
              <el-select v-model="filter.status" placeholder="请选择状态" size="small">
                <el-option
                  key=""
                  label="请选择状态"
                  value="">
                </el-option>
                <el-option
                  v-for="item in statusSearchOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)">
                </el-option>
              </el-select>
              <el-input placeholder="搜索名称" v-model.trim="filter.search" clearable class="m-lr-5" style="width:200px;" size="small"></el-input>
              <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="template_id_name" label="模板"></el-table-column>
            <el-table-column prop="status_name" label="状态"></el-table-column>
            <el-table-column prop="source" label="来源"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="plan_send_time" label="计划发布时间"></el-table-column>
            <el-table-column prop="prepare_time" label="预处理时间"></el-table-column>
            <el-table-column prop="estimate_count" label="预计推送人数"></el-table-column>
            <!-- <el-table-column prop="prepare_count" label="预处理入队人数"></el-table-column> -->
            <el-table-column prop="success_count" label="发送成功人数"></el-table-column>
            <el-table-column prop="fail_count" label="失败人数"></el-table-column>
            <el-table-column prop="result_time" label="发布完成时间"></el-table-column>
            <el-table-column width="160" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="editHandle(scope.row)"
                  type="primary"
                  size="small">
                  查看
                </el-button>
                <el-button
                  @click="deleteHandle(scope.row.id)"
                  size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加任务" :modal-append-to-body="false" :visible.sync="dialogVisible" width="1000px" class="phone-d" @close="handleExit">
      <el-steps :active="step" :align-center="true">
        <el-step title="发什么" icon="el-icon-edit"></el-step>
        <el-step title="发给谁" icon="el-icon-user"></el-step>
        <el-step title="发送" icon="el-icon-finished"></el-step>
      </el-steps>
      <el-form ref="formTable" :rules="rules" :model="form" label-width="120px" size="small" v-loading="dialogLoading" style="padding-top:40px;">
        <div v-show="step == '1'">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" style="width: 90%;"></el-input>
            <span class="m-l-5" style="color:#999;">仅自己可见</span>
          </el-form-item>
          <el-form-item label="消息模板" prop="template_id">
            <el-select v-model="form.template_id" placeholder="请选择">
              <el-option :label="item.title" v-for="(item, index) in temList" :key="index" :value="item.template_id"></el-option>
            </el-select>
          </el-form-item>
          <el-row style="background: url(data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMxaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0MCA3OS4xNjA0NTEsIDIwMTcvMDUvMDYtMDE6MDg6MjEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjkwODU5RjZFODlDNjExRTk4OTQ5QjczOTY4NTJDNTk4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjkwODU5RjZGODlDNjExRTk4OTQ5QjczOTY4NTJDNTk4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjMwMEY2N0Y4OUM1MTFFOTg5NDlCNzM5Njg1MkM1OTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjMwMEY2ODA4OUM1MTFFOTg5NDlCNzM5Njg1MkM1OTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wAARCAAKA+gDAREAAhEBAxEB/8QATwABAQEBAAAAAAAAAAAAAAAAAAMECAEBAAAAAAAAAAAAAAAAAAAAABABAQEAAAAAAAAAAAAAAAAAAEEDEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDqkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE9YCYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ6wEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/Z) repeat-y center;background-size: 100% auto;" v-if="form.template_id !== ''">
            <el-col :span="14" style="background: #fff;padding: 25px 0 0px;min-height: 200px;">
              <el-form ref="contentTable" :rules="contentRules" :model="content" label-width="120px" size="small">
                <el-form-item :label="item.title" v-for="(item, index) in contentList" :key="index" :prop="item.key">
                  <el-input type="textarea" v-model="content[item.key]" @change="inputChange(content[item.key], item.key)" style="width: 90%;"></el-input>
                  <span class="colorSpan" @click="showColorFn(item.key)" :style="'background:' + contentColor[item.key] + ';margin-right: 10px;'"></span>
                </el-form-item>
              </el-form>
              <el-form-item label="跳转链接">
                <el-radio-group v-model="urlType">
                  <el-radio label="0">无</el-radio>
                  <el-radio label="1">网页地址</el-radio>
                  <el-radio label="2">小程序地址</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="网页地址" prop="url" v-if="Number(urlType) === 1">
                <el-input v-model="form.url" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="回流监控" prop="is_tk" v-if="Number(urlType) === 1">
                <el-radio v-model="form.is_tk" label="1">是</el-radio>
                <el-radio v-model="form.is_tk" label="0">否</el-radio>
              </el-form-item>
              <el-form-item label="appid" prop="appid" v-if="Number(urlType) === 2">
                <el-input v-model="form.appid" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="pagepath" prop="pagepath" v-if="Number(urlType) === 2">
                <el-input v-model="form.pagepath" style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <div class="prview">
                <div class="prview-title">模板预览</div>
                <div class="prview-box auto">
                  <div class="prview-box-title">{{temList.find(item => {return item.template_id == form.template_id}).title}}</div>
                  <div class="prview-box-content">
                    <ul>
                      <li v-for="(item, index) in contentList" :key="index">{{index === contentList.length - 1 ? '' : (item.title + '：')}}<span :style="'color:' + contentColor[item.key]" v-html="content[item.key].replace(/\n/g, '<br>').replace(/  /g, '&nbsp;&nbsp;')"></span></li>
                    </ul>
                  </div>
                  <div class="prview-box-control" v-show="urlType !== '0'">
                    <span>详情</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-show="step == '2'" class="custom-transfer">
          <el-form-item label="人群包" prop="package_id">
            <el-transfer
              disabled
              filterable
              :titles="['可选项', '已选项']"
              filter-placeholder="请输入关键字搜索"
              v-model="form.package_id"
              :data="packageList">
            </el-transfer>
          </el-form-item>
          <!-- <el-form-item label="选中人数" v-if="form.filter_type === 'query'">
            {{count}}
          </el-form-item> -->
          <el-form-item label="发布时间" prop="plan_send_time">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.plan_send_time" type="datetime" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
        </div>
        <div class="step3" v-show="step == '3'">
          <img src="@/assets/success.png" alt="">
          <br>
          <el-button type="success" @click="showPreview" size="small">预览</el-button>
          <p>整体推送前可以先预览推送效果，防止出错。</p>
        </div>
        <el-form-item v-show="!isCheck && step == '1'" align="center" style="margin-top: 20px;">
          <p style="margin-left:-120px;"><el-button type="primary" @click="goStepTwo">下一步</el-button></p>
        </el-form-item>
        <el-form-item v-show="!isCheck && step == '2'" align="center" style="margin-top: 20px;">
          <p style="margin-left:-120px;">
            <el-button @click="goBackStepOne">上一步</el-button>
            <el-button type="primary" @click="goStepThree">下一步</el-button>
          </p>
        </el-form-item>
        <el-form-item v-show="!isCheck && step == '3'" align="center" style="margin-top: 20px;">
          <p style="margin-left:-120px;">
            <el-button @click="goBackStepTwo">上一步</el-button>
            <el-button type="primary" @click="handleSubmit">发送</el-button>
            <!-- <el-button @click="handleExit">取消</el-button> -->
          </p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div class="colorBox" v-show="colorShow">
      <photoshop v-model="color" @cancel="cancelFn" @ok="okFn" @input="updateValue" style="margin:200px auto 0;"></photoshop>
    </div>
    <el-dialog title="查看任务" :modal-append-to-body="false" :visible.sync="editVisible" v-loading="dialogLoading" width="1000px" class="phone-d" @close="handleExit">
      <el-form :model="form" label-width="120px" size="small">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="消息模板" prop="template_id">
          <el-select v-model="form.template_id" placeholder="请选择" disabled>
            <el-option :label="item.title" v-for="(item, index) in temList" :key="index" :value="item.template_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form ref="contentTable" :rules="contentRules" :model="content" label-width="120px" size="small" v-if="content !== ''">
          <el-form-item :label="item.title" v-for="(item, index) in contentList" :key="index" :prop="item.key" style="position: relative;">
            <el-input type="textarea" v-model="content[item.key]" disabled style="width: 95%;"></el-input>
            <span class="colorSpan" @click.stop="showColorFn(item.key)" :style="'background:' + contentColor[item.key]"></span>
            <div style="width:100%;height:100%;position:absolute;left:0;top:0;z-index:999;"></div>
          </el-form-item>
        </el-form>
        <el-form-item label="网页地址" prop="url" v-if="form.url !== ''">
          <el-input v-model="form.url" disabled></el-input>
        </el-form-item>
        <el-form-item label="回流监控" prop="is_tk" v-if="form.url !== ''">
          {{Number(form.is_tk) ? '是' : '否'}}
        </el-form-item>
        <el-form-item label="appid" prop="appid" v-if="form.appid !== ''">
          <el-input v-model="form.appid" disabled></el-input>
        </el-form-item>
        <el-form-item label="pagepath" prop="pagepath" v-if="form.pagepath !== ''">
          <el-input v-model="form.pagepath" disabled></el-input>
        </el-form-item>
        <el-form-item label="人群包" prop="package_id">
          <ul v-if="form.package_id.length && packageList.length">
            <li v-for="(item, index) in form.package_id" :key="index" v-if="packageList.find(item2 => {return item2.key === item})">{{packageList.find(item2 => {return item2.key === item})['label']}}</li>
          </ul>
        </el-form-item>
        <el-form-item label="发布时间" prop="plan_send_time">
          <el-date-picker v-model="form.plan_send_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" disabled placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="发送预览" :modal-append-to-body="false" :visible.sync="previewVisible" v-loading="previewLoading" width="50%" class="phone-d">
      <el-form ref="previewForm" :rules="previewrules" :model="preview" label-width="80px" size="small">
        <el-form-item label="">
          <p>关注公众号后，才能接收图文消息预览</p>
        </el-form-item>
        <el-form-item prop="wxOpenid" label="openid">
          <el-input type="text" v-model.trim="preview.wxOpenid" placeholder="输入预览的微信openid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePreviewFn">确定</el-button>
          <el-button @click="previewExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Mp } from '@/model'
import { Photoshop } from 'vue-color'
import VueCookie from 'vue-cookie'
export default {
  data () {
    let token = VueCookie.get('eub_oa_token')
    let authorizer = VueCookie.get('eub_oa_current')
    return {
      uploadData: { token, authorizer },
      queryLoading: false,
      statusSearchOptions: [],
      id: '',
      color: '#194d33',
      colorShow: false,
      colorKey: '',
      loading: true,
      search: '',
      tableData: [],
      pageSize: 20,
      currentPage: 1,
      isCheck: false,
      urlType: '0',
      form: {
        name: '',
        template_id: '',
        url: '',
        is_tk: '1',
        appid: '',
        pagepath: '',
        package_id: [],
        sub_time: [],
        event_time: [],
        plan_send_time: '',
        file_path: ''
      },
      openidList: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        template_id: [
          { required: true, message: '请选择模板', trigger: 'change' }
        ],
        url: [
          { required: false, message: '请填写地址', trigger: 'blur' }
        ],
        appid: [
          { required: false, message: '请填写appid', trigger: 'blur' }
        ],
        pagepath: [
          { required: false, message: '请填写pagepath', trigger: 'blur' }
        ],
        package_id: [
          { type: 'array', required: true, message: '请选择人群包', trigger: 'change' }
        ],
        plan_send_time: [
          { required: true, message: '请选择发布时间', trigger: 'blur' }
        ],
        file_path: [
          { required: false, message: '请上传文件', trigger: 'blur' }
        ]
      },
      temList: [],
      content: {},
      contentColor: {},
      contentList: [],
      contentRules: {},
      dialogVisible: false,
      dialogLoading: false,
      editVisible: false,
      previewVisible: false,
      previewLoading: false,
      preview: {
        wxOpenid: ''
      },
      previewrules: {
        wxOpenid: [
          { required: false, message: '预览微信openid不能为空！', trigger: 'blur' }
        ]
      },
      filter: {
        template_id: '',
        status: '',
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0,
      isAdd: false,
      step: 1,
      uploadLoading: false,
      packageList: []
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    },
    'form.template_id': function (val) {
      if (val !== '' && this.isAdd) {
        this.getTemplateFields(val)
      }
    },
    'form.package_id': function (newval, oldval) {
      if (newval.length > 5) {
        this.$message.error('最多只能选5个人群包!')
        this.form.package_id = oldval
      }
    },
    'urlType': function (val) {
      if (val === '0') {
        this.rules.url[0].required = false
        this.rules.appid[0].required = false
        this.rules.pagepath[0].required = false
      } else if (val === '1') {
        this.rules.url[0].required = true
        this.rules.appid[0].required = false
        this.rules.pagepath[0].required = false
      } else if (val === '2') {
        this.rules.url[0].required = false
        this.rules.appid[0].required = true
        this.rules.pagepath[0].required = true
      }
    }
  },
  components: {
    Photoshop
  },
  methods: {
    goStepTwo () {
      var isClear = true
      this.$refs['contentTable'].validate((valid) => {
        if (valid) {
          if (!this.form.package_id.length || !this.form.plan_send_time) {
            this.form.plan_send_time = '2019-09-09'
            this.form.package_id = [this.packageList[0]['key']]
          } else {
            isClear = false
          }
          this.$refs['formTable'].validate((valid) => {
            if (valid) {
              if (isClear) {
                this.form.plan_send_time = ''
                this.form.package_id = []
              }
              this.step = 2
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    goStepThree () {
      this.$refs['formTable'].validate((valid) => {
        if (valid) {
          this.$refs['contentTable'].validate((valid) => {
            if (valid) {
              this.step = 3
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    goBackStepOne () {
      this.step = 1
    },
    goBackStepTwo () {
      this.step = 2
    },
    inputChange (val, keyname) {
      // console.log(val, keyname)
      this.content[keyname] = val
      this.content = Object.assign({}, this.content)
    },
    checkEmpty (item) {
      var status = false
      if (item.child_time && !item.child_time.length) {
        return status
      }
      for (var item2 in item.filter) {
        if (item.filter[item2] !== '' && item.filter[item2].length > 0) {
          status = true
        }
      }
      return status
    },
    getValues (obj) {
      if (obj.type) {
        this.chooseVal[obj.type] = obj['value']
      } else {
        this.chooseVal = obj['value']
      }
      // this.page = 1
      this.chooseVal = JSON.parse(JSON.stringify(this.chooseVal))
      this.changeChoiceFn()
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        template_id: '',
        status: '',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/custom/template', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.searchHandle()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    handlePreviewFn () {
      this.$refs['formTable'].validate((valid) => {
        if (valid) {
          this.$refs['contentTable'].validate((valid) => {
            if (valid) {
              this.$refs['previewForm'].validate((valid) => {
                if (valid) {
                  // if (this.form.filter_type === 'query' && Number(this.count) === 0) {
                  //   this.$message.error('未选中任何人')
                  // } else {
                  this.previewLoading = true
                  this.handlePreview()
                  // }
                } else {
                  return false
                }
              })
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    async handlePreview () {
      var contentNew = {}
      for (var key in this.content) {
        contentNew[key] = {}
        contentNew[key]['value'] = this.content[key]
        contentNew[key]['color'] = this.contentColor[key]
      }
      let postData = {
        openid: this.preview.wxOpenid,
        template_id: this.form.template_id,
        content: contentNew
      }
      if (this.urlType === '1') {
        postData['url'] = this.form.url
      }
      if (this.urlType === '2') {
        postData['miniprogram'] = {
          appid: this.form.appid,
          pagepath: this.form.pagepath
        }
      }
      let res = await Mp.Template.previewTemplate(postData)
      if (!res.err_code) {
        this.$message.success(res.err_msg)
        this.previewLoading = false
        this.previewVisible = false
      } else {
        this.$message.error(res.err_msg)
        this.previewLoading = false
      }
    },
    showPreview () {
      this.previewVisible = true
    },
    previewExit () {
      this.previewVisible = false
    },
    resetFn () {
      this.form = {
        name: '',
        template_id: '',
        url: '',
        is_tk: '1',
        appid: '',
        pagepath: '',
        package_id: [],
        openid_list: '',
        sub_time: [],
        event_time: [],
        plan_send_time: '',
        file_path: ''
      }
      this.content = {}
      this.contentColor = {}
      this.contentList = []
      this.contentRules = {}
      this.urlType = '0'
    },
    showColorFn (val) {
      this.colorKey = val
      this.colorShow = true
    },
    cancelFn () {
      this.colorShow = false
    },
    okFn () {
      this.contentColor[this.colorKey] = this.color.hex
      this.colorShow = false
    },
    updateValue (val) {
      // this.colorUpadte = val.hex
    },
    addHandle () {
      if (!this.packageList.length) {
        this.$confirm('当前无人群包可用，点击确定前往添加人群包', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/mp/custom/package')
        })
      } else {
        this.step = 1
        this.isAdd = true
        this.dialogVisible = true
        if (this.temList.length) {
          this.form.template_id = this.temList[0].template_id
        }
      }
    },
    async searchHandle () {
      this.loading = true
      let res = await Mp.Template.getTemplateSendTask(this.filter)
      this.tableData = res.data.list
      this.total = res.data.total
      this.loading = false
    },
    handleSubmit () {
      this.$refs['formTable'].validate((valid) => {
        if (valid) {
          this.$refs['contentTable'].validate((valid) => {
            if (valid) {
              // if (this.form.filter_type === 'query' && Number(this.count) === 0) {
              //   this.$message.error('未选中任何人')
              // } else {
              // this.openidList = this.form.openid_list.split('\n')
              this.handleSubmitFn()
              // }
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    async handleSubmitFn () {
      var contentNew = {}
      for (var key in this.content) {
        contentNew[key] = {}
        contentNew[key]['value'] = this.content[key]
        contentNew[key]['color'] = this.contentColor[key]
      }
      this.dialogLoading = true
      let postData = {
        name: this.form.name,
        template_id: this.form.template_id,
        content: contentNew,
        package_id: this.form.package_id,
        plan_send_time: this.form.plan_send_time
      }
      if (this.urlType === '1') {
        postData['url'] = this.form.url
        postData['is_tk'] = this.form.is_tk
      }
      if (this.urlType === '2') {
        postData['miniprogram'] = {
          appid: this.form.appid,
          pagepath: this.form.pagepath
        }
      }
      let res = await Mp.Template.saveTemplateSendTask(postData)
      if (!res.err_code) {
        this.$message.success('添加成功！')
        this.dialogVisible = false
        this.resetFn()
        setTimeout(() => {
          this.resetFilter()
          this.searchHandle()
        }, 200)
      } else {
        this.$message.error(res.err_msg)
      }
      this.dialogLoading = false
    },
    handleExit () {
      this.dialogVisible = false
      this.editVisible = false
      this.resetFn()
    },
    editHandle (row) {
      this.isAdd = false
      this.editVisible = true
      this.id = row.id
      this.form = {
        name: row.name,
        template_id: row.template_id,
        url: row.url,
        is_tk: row.is_tk,
        appid: row.miniprogram ? JSON.parse(row.miniprogram).appid : '',
        pagepath: row.miniprogram ? JSON.parse(row.miniprogram).pagepath : '',
        package_id: JSON.parse(row.package_id),
        plan_send_time: row.plan_send_time.indexOf('0000') > -1 ? '' : row.plan_send_time
      }
      this.content = row.content
      this.urlType = '0'
      this.getTemplateFields(row.template_id, () => {
        this.getTaskDetail(row.id)
      })
    },
    async getTaskDetail (id) {
      this.dialogLoading = true
      let res = await Mp.Template.getTaskDetail({id: id})
      if (!res.err_code) {
        this.form.openid_list = res.data.openid_list
        var content = JSON.parse(res.data.content)
        for (var key in content) {
          this.content[key] = content[key].value
          this.contentColor[key] = content[key].color
        }
        this.content = Object.assign({}, this.content)
      } else {
        this.$message.error(res.err_msg)
      }
      this.dialogLoading = false
    },
    deleteHandle (id) {
      this.$confirm('此操作将删除该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFn(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async deleteFn (id) {
      let res = await Mp.Template.delTask({id: id})
      if (!res.err_code) {
        this.$message.success('删除成功！')
        this.searchHandle()
        this.handleExit()
      } else {
        this.$message.error(res.err_msg)
      }
    },
    async getTemplateSendTask () {
      let resSync = await Mp.Template.syncTemplateList()
      if (resSync.err_code) {
        this.$message.error(resSync.err_msg)
      }
      let resTemplate = await Mp.Template.getTemplateList()
      this.temList = resTemplate.data.list
      let resStatus = await Mp.Template.getStatusList()
      resStatus.data.map((item, index) => {
        this.statusSearchOptions.push({
          id: index,
          name: item
        })
      })
    },
    async syncTemplateList () {
      this.loading = true
      let res = await Mp.Template.syncTemplateList()
      if (!res.err_code) {
        this.$message.success('同步成功！')
        this.resetFilter()
        this.searchHandle()
      } else {
        this.$message.error(res.err_msg)
      }
      this.loading = false
    },
    async getTemplateFields (id, cb) {
      this.content = {}
      this.contentList = []
      this.contentRules = {}
      this.contentColor = {}
      this.dialogLoading = true
      let res = await Mp.Template.getTemplateFields({
        template_id: id
      })
      if (!res.err_code) {
        res.data.map(item => {
          this.content[item.key] = ''
          this.contentRules[item.key] = []
          this.contentColor[item.key] = ''
          this.contentRules[item.key][0] = { required: true, message: '请填写完整', trigger: 'blur' }
        })
        this.content = Object.assign({}, this.content)
        this.contentList = res.data
        if (cb) {
          // setTimeout(() => {
          cb()
          // }, 1000)
        }
      } else {
        this.$message.error(res.err_msg)
      }
      this.dialogLoading = false
    },
    async changeChoiceFn () {
      this.dialogLoading = true
      let result = await Mp.Template.getUserFilterCount({
        filter: JSON.stringify(this.chooseVal)
      })
      this.count = result.data.count
      this.dialogLoading = false
    },
    async getFilterPackageList () {
      let res = await Mp.System.getFilterPackageList()
      if (!res['err_code']) {
        let options = []
        res['data'].map(item => {
          options.push({
            label: item.name + '（' + item.total + '人）',
            key: item.id
          })
        })
        this.packageList = options
      }
    }
  },
  created () {
    this.queryToFilter()
    this.getTemplateSendTask()
    this.getFilterPackageList()
  }
}
</script>

<style scoped>
.colorBox {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;
  z-index: 999999;
}
.colorSpan {
  display: block;
  width: 30px;
  height: 30px;
  float: right;
  background: #000;
}

.prview {
  padding: 30px 0 30px 100px;
}
.prview-title {
  color: #000;
}
.prview-box {
  width: 260px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 10px;
  margin-top: 10px;
}
.prview-box-title {
  font-size: 16px;
  color: #000;
}
.prview-box-content {
  padding: 20px 0;
}
.prview-box-content ul li {
  line-height: 24px;
}
.prview-box-control {
  border-top: 1px solid #ddd;
  line-height: 24px;
  padding-top: 5px;
}
.prview-box-control span {
  float: left;
}
.prview-box-control i {
  float: right;
  margin-top: 5px;
}

.step3 {
  text-align: center;
}
.step3 img {
  margin-top: 20px;
}
.step3 button {
  margin: 20px 0;
}
.step3 p {
  color: #999;
  margin: 20px 0;
  padding-bottom: 40px;
}
</style>
